export const supportTicketColumns = [
  { label: 'Código', value: 'reference_number' },
  { label: 'Chamado', value: 'ticket_type' },
  { label: 'Status', value: 'status' },
  { label: 'Motivo', value: 'reason' },
  { label: 'Autor', value: 'creator' },
  { label: 'Quando', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
